const EmptyState = ({
  title,
  description,
  image = "/images/empty.png",
  imageAlt = "",
  action,
  className = "",
  imageClassName = "size-20 opacity-70",
  minHeight,
}) => (
  <div
    className={`flex flex-col items-center justify-center gap-3 py-10 text-center text-gray-500 ${className}`}
    style={minHeight ? { minHeight } : undefined}
  >
    {image && (
      <img
        src={image}
        alt={imageAlt}
        aria-hidden={imageAlt ? undefined : "true"}
        className={imageClassName}
      />
    )}
    <div className="space-y-1">
      {title && <p className="font-sf-medium text-gray-700">{title}</p>}
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
    {action}
  </div>
);

export default EmptyState;
